import {FC, useContext} from 'react';
import {Formik} from 'formik';
import {Box, Typography} from '@mui/material';
import {BODY1, H4, LOGIN, SIGN_UP, TEXT} from '@/utils/constants';
import Button from '@/shared/components/Button';
import FormContent from './FormContent';
import SocialFormActions from '../SocialFormActions';
import {CreateAccountFormValues, initialValues, validationSchema} from './formConfiguration';
import {FormDataContext} from '../../FormDataContext';
import {POPUP_FORM} from '../../helpers';
import {IUserRegisterRequest} from '@/utils/types/user.interface';
import {useAppDispatch, useAppSelector} from '@/store/hooks';
import {getUserInfo, userSignup} from '@/store/user';
import {USER_TYPE} from '@/utils/enums';
import {UserService, userStorage} from '@/utils/services';
import {useNavigate, useParams} from 'react-router-dom';
import {createUserAccountFormStyle} from './CreateUserAccountForm.styles';
import {toast} from 'react-toastify';
import {getErrorMessage} from '@/utils/helpers';
import {getCurrentEventSelector} from '@/store/organization-event/selector';

const CreateUserAccountForm: FC = () => {
  const {slug} = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const event = useAppSelector(getCurrentEventSelector);

  const {changePopupFormHandler} = useContext(FormDataContext);

  const handleSubmitClickHandler = async (values: CreateAccountFormValues) => {
    if (!event?.id) return;
    const {firstName, lastName, email, password} = values;

    const requestBody: IUserRegisterRequest = {
      firstName,
      lastName,
      email,
      password,
    };

    try {
      const {userInfo} = await dispatch(userSignup(requestBody)).unwrap();

      if (userInfo && userInfo.id) {
        const {data} = await UserService.ensureUserHaveAttendeeIdentity(event?.id);

        if (data.attendeeId) {
          await dispatch(getUserInfo(userInfo.id)).unwrap();
        }
        userStorage.set('userType', USER_TYPE.USER);
        navigate(`/${slug}`);
      }
    } catch (error) {
      toast.error(getErrorMessage(error));
    }
  };

  const logInClickHandler = () => changePopupFormHandler(POPUP_FORM.LOGIN);
  return (
    <Box sx={createUserAccountFormStyle.wrapper}>
      <Typography sx={createUserAccountFormStyle.title} variant={H4}>
        {SIGN_UP}
      </Typography>

      <SocialFormActions />

      <Formik initialValues={initialValues} onSubmit={handleSubmitClickHandler} validationSchema={validationSchema}>
        <FormContent />
      </Formik>

      <Typography sx={createUserAccountFormStyle.logIn} variant={BODY1}>
        Already have an account?
        <Button
          variant={TEXT}
          disableRipple
          onClick={logInClickHandler}
          title={LOGIN}
          sx={createUserAccountFormStyle.button}
        />
      </Typography>
    </Box>
  );
};

export default CreateUserAccountForm;
